/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  AllHTMLAttributes,
} from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';

import { Container, Divisor } from './styles';
import { useToast } from '../../../../../hooks/toast';
import api from '../../../../../services/api';
import SimpleButton from '../../../../SimpleButton';
import Modal from '../../../../Modal';
import { addListInfo } from '../../../../../store/modules/list/actions';

type IModal = AllHTMLAttributes<HTMLAllCollection> & {
  modalStatus: boolean;
  listId: string;
};

const ReproveList: React.FC<IModal> = ({ modalStatus, listId }) => {
  const formRef = useRef<FormHandles>(null);
  const { addToast } = useToast();

  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    const modalChange = async (): Promise<void> => {
      if (modalStatus) {
        await setModal(true);
        await setModal(false);
      }
    };

    modalChange();
  }, [modalStatus]);

  const handleSubmit = useCallback(
    async id => {
      await setLoading(true);
      await api.put('/list/disable', { id }).then(async response => {
        toast.success(`Lista ${response.data.name} desativada com sucesso!`);
        setModal(true);

        await api.get(`/list/lists`).then(obj => {
          dispatch(addListInfo(obj.data));
        });
      });
      await setLoading(false);
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [addToast],
  );

  return (
    <Modal
      title="Desabilitar lista"
      modalSize="50%"
      modalClose={modal}
      closable
    >
      <Container>
        <Form ref={formRef} onSubmit={() => handleSubmit(listId)}>
          <h3 className="modal-question text-center">
            Deseja realmente desativar esta lista?
          </h3>
          <Divisor className="modal-form_button-divisor">
            <div className="modal-simplebuttons">
              <div>
                <SimpleButton
                  className="modal-simplebutton"
                  // backgroundHoverColor="#a50000"
                  loading={loading}
                  type="submit"
                >
                  Desativar
                </SimpleButton>
              </div>
              <div>
                <button
                  type="button"
                  className="modalbutton-cancelar"
                  onClick={() => setModal(true)}
                >
                  não, cancelar
                </button>
              </div>
            </div>
          </Divisor>
        </Form>
      </Container>
    </Modal>
  );
};

export default ReproveList;
